import { Text, TextProps } from '@rbilabs/universal-components';
import { DISABLE_STORE_CHANGE_DIALOG } from 'features/store/constants';

import { t } from 'state/intl/translations';

interface Props extends TextProps {}

export const StoreChangeDisclaimer = (props: Props) => {
  if (DISABLE_STORE_CHANGE_DIALOG) {
    return (
      <Text fontSize="xs" {...props}>
        {t('changingYourStoreDisclaimer')}
      </Text>
    );
  }
  return null;
};
